import { render, staticRenderFns } from "./UpdateLocation.vue?vue&type=template&id=277bb984&scoped=true&"
import script from "./UpdateLocation.vue?vue&type=script&lang=ts&"
export * from "./UpdateLocation.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateLocation.vue?vue&type=style&index=0&id=277bb984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277bb984",
  null
  
)

export default component.exports